import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = { running: "#22C55E", restarting: "#38BDF8", paused: "#F59E0B", stopped: "#6B7280", error: "#EF4444", missing: "#F97316", unknown: "#A78BFA" };
const LABELS = { running: "Ativos", restarting: "Reiniciando", paused: "Pausados", stopped: "Parados", error: "Erro", missing: "Ausentes", unknown: "Desconhecidos" };

// Donut de status de containers com centro e legenda.
export const ContainerDonut = ({ summary }) => {
  const entries = ["running", "restarting", "paused", "stopped", "error", "missing", "unknown"];
  const data = entries.map((k) => ({ name: k, value: summary[k] || 0 }));
  const total = summary.total || data.reduce((a, b) => a + b.value, 0);

  return (
    <div className="flex flex-col items-center gap-5">
      <div className="relative h-36 w-36 shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="value" innerRadius={48} outerRadius={66} paddingAngle={2} stroke="none" startAngle={90} endAngle={-270} isAnimationActive={false}>
              {data.map((d) => (
                <Cell key={d.name} fill={COLORS[d.name]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-heading text-3xl font-bold text-foreground">{total}</span>
          <span className="text-[11px] text-muted-foreground">Containers</span>
        </div>
      </div>
      <div className="flex w-full flex-col gap-2.5">
        {entries.map((k) => {
          const v = summary[k] || 0;
          const pct = total ? Math.round((v / total) * 100) : 0;
          return (
            <div key={k} className="flex items-center gap-2 text-sm">
              <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: COLORS[k] }} />
              <span className="text-muted-foreground">{LABELS[k]}</span>
              <span className="ml-auto font-mono text-foreground">{v}</span>
              <span className="w-10 shrink-0 text-right font-mono text-xs text-muted-foreground">{pct}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
